import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { reset as resetForm } from 'redux-form';
import ExternalTopUpPage from './ExternalTopUpPage';
import IntegratedTopUpPage from './IntegratedTopUpPage';
import { actions as externalAccountActions } from '../../../common/externalAccount';
import { selectors as transitionRouterSelectors } from '../../../common/transitionRouter';
import { selectors as userInfoSelectors } from '../../../common/userInfo';
import {
    actions as bookmakersListActions,
    selectors as bookmakersListSelectors,
} from '../../../common/bookmakersList';
import { selectors as bookmakersInfoSelectors } from '../../../common/bookmakersInfo';
import { actions as topUpActions } from '../../../common/topUp';

export class TopUpPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            shouldRedirectToBetPage: false,
        };
    }

    componentWillMount() {
        const {
            apiName,
            getExternalAccountUrl,
            isExternalAccount,
        } = this.props

        if (isExternalAccount) {
            getExternalAccountUrl(apiName)
        }
    }

    componentWillUnmount() {
        this.props.clearExternalAccountData();
    }

    redirectToBetPage = () => {
        this.setState({ shouldRedirectToBetPage: true });
    }

    render() {
        const {
            match,
            name,
            isUserLoggedIn,
            userInfo,
            accountType,
            isExternalAccount,
            isExternalAccountError,
            externalAccountUrl,
            containsTermsInTopUpIframe,
            apiName,
            isTopUpModalVisible,
            topUpErrorInfo,
            cardDetails,
            isCardDetailsError,
            isPhone,
            hideTopUpModal,
            getUserInfo,
            topUpAccountBalance,
            getCardDetails,
            currencySign,
            resetTopUpForm,
            topUpBookmakerUrl,
            topUpBookmakerName,
            topUpPhoneNumber,
        } = this.props;

        if (this.state.shouldRedirectToBetPage) {
            return (<Redirect
                to={{
                    pathname: '/',
                    state: { isReversedAnimation: true },
                }}
            />);
        }

        return (
            isExternalAccount ? (
                <ExternalTopUpPage
                    feed={match.params.feed}
                    name={name}
                    userInfo={userInfo}
                    isUserLoggedIn={isUserLoggedIn}
                    containsTermsInTopUpIframe={containsTermsInTopUpIframe}
                    accountType={accountType}
                    externalAccountUrl={externalAccountUrl}
                    isExternalAccountError={isExternalAccountError}
                    onExternalBackButtonClick={this.redirectToBetPage}
                />
            ) : (
                <IntegratedTopUpPage
                    feed={match.params.feed}
                    name={name}
                    userInfo={userInfo}
                    isUserLoggedIn={isUserLoggedIn}
                    apiName={apiName}
                    isTopUpModalVisible={isTopUpModalVisible}
                    currencySign={currencySign}
                    hideTopUpModal={hideTopUpModal}
                    getUserInfo={getUserInfo}
                    topUpAccountBalance={topUpAccountBalance}
                    getCardDetails={getCardDetails}
                    topUpErrorInfo={topUpErrorInfo}
                    cardDetails={cardDetails}
                    isCardDetailsError={isCardDetailsError}
                    resetTopUpForm={resetTopUpForm}
                    topUpBookmakerUrl={topUpBookmakerUrl}
                    topUpBookmakerName={topUpBookmakerName}
                    topUpPhoneNumber={topUpPhoneNumber}
                    isPhone={isPhone}
                />
            )
        );
    }
}

TopUpPage.defaultProps = {
    isUserLoggedIn: false,
    accountType: 'form',
    isExternalAccount: false,
    apiName: '',
    externalAccountUrl: '',
    isExternalAccountError: false,
    containsTermsInTopUpIframe: false,
    isTopUpModalVisible: false,
    topUpErrorInfo: null,
    cardDetails: null,
    isCardDetailsError: false,
    topUpPhoneNumber: '',
    topUpBookmakerUrl: '',
    topUpBookmakerName: '',
}

TopUpPage.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            feed: PropTypes.string,
        }),
    }).isRequired,
    name: PropTypes.string.isRequired,
    isUserLoggedIn: PropTypes.bool,
    userInfo: PropTypes.shape({
        name: PropTypes.string,
        balance: PropTypes.number.isRequired,
        showBalance: PropTypes.bool,
        currencySign: PropTypes.string.isRequired,
    }).isRequired,
    apiName: PropTypes.string,
    accountType: PropTypes.string,
    isExternalAccount: PropTypes.bool,
    getExternalAccountUrl: PropTypes.func.isRequired,
    clearExternalAccountData: PropTypes.func.isRequired,
    externalAccountUrl: PropTypes.string,
    isExternalAccountError: PropTypes.bool,
    containsTermsInTopUpIframe: PropTypes.bool,
    isTopUpModalVisible: PropTypes.bool,
    topUpErrorInfo: PropTypes.shape({
        code: PropTypes.string,
    }),
    cardDetails: PropTypes.shape({
        cardId: PropTypes.string,
        cardNumber: PropTypes.string,
    }),
    isCardDetailsError: PropTypes.bool,
    isPhone: PropTypes.bool.isRequired,
    hideTopUpModal: PropTypes.func.isRequired,
    getUserInfo: PropTypes.func.isRequired,
    topUpAccountBalance: PropTypes.func.isRequired,
    getCardDetails: PropTypes.func.isRequired,
    currencySign: PropTypes.string.isRequired,
    resetTopUpForm: PropTypes.func.isRequired,

    topUpPhoneNumber: PropTypes.string,
    topUpBookmakerUrl: PropTypes.string,
    topUpBookmakerName: PropTypes.string,
}

const userInfoSelector =
    userInfoSelectors.createUserInfoSelector(
        bookmakersInfoSelectors.betBookmakerSelector,
    );
const bookmakerInfoSelector =
    bookmakersListSelectors.createBookmakerInfoSelector(
        bookmakersInfoSelectors.betBookmakerSelector,
    );
const userIsLoggedInSelector = bookmakersListSelectors.createIsLoggedInSelector(
    bookmakersInfoSelectors.betBookmakerSelector,
);
const userCurrencySignSelector =
    userInfoSelectors.createUserCurrencySignSelector(
        transitionRouterSelectors.feedSelector,
    );

const mapStateToProps = (state, props) => {
    const {
        isExternalAccountError,
        externalAccountUrl,
    } = state.externalAccount;
    const {
        isTopUpModalVisible,
        topUpErrorInfo,
        cardDetails,
        isCardDetailsError,
    } = state.topUp;

    return {
        ...bookmakerInfoSelector(state),
        isUserLoggedIn: userIsLoggedInSelector(state),
        userInfo: userInfoSelector(state, props),
        isExternalAccountError,
        externalAccountUrl,
        isPhone: state.pageInfo.isPhone,
        isTopUpModalVisible,
        topUpErrorInfo,
        cardDetails,
        isCardDetailsError,
        currencySign: userCurrencySignSelector(state, props),
    };
};

const mapDispatchToProps = {
    getExternalAccountUrl: externalAccountActions.getExternalAccountUrl,
    clearExternalAccountData: externalAccountActions.clearExternalAccountData,
    hideTopUpModal: topUpActions.hideTopUpModal,
    getCardDetails: topUpActions.getCardDetails,
    topUpAccountBalance: topUpActions.topUpAccountBalance,
    getUserInfo: bookmakersListActions.getUserInfo,
    resetTopUpForm: resetForm.bind(null, 'topUpForm'),
};

export default connect(mapStateToProps, mapDispatchToProps)(TopUpPage);



// WEBPACK FOOTER //
// /src/js/drawer/components/TopUpPage/TopUpPage.jsx